<template>
  <div class="splash-box">
    <div class="logo_box">
      <img class="logo" src="../assets/img/common/logo_loading.png"/>

      <i class="gear_big">

      </i>

      <i class="gear_small">

      </i>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'loading',
    created() {
      let _that = this;
      this.timer = setTimeout(() => {
        _that.goToLogin();
      }, 2000);
    },
    data() {
      return {
        timer: ''
      };
    },
    methods: {
      goToLogin() {
        clearTimeout(this.timer);
        this.$router.push({path: '/login'});
      }
    },
    destroy() {
      clearTimeout(this.timer);
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">

  @import "../assets/scss/base";


  @keyframes change {
    0% {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(180deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }


  .splash-box {
    background: url('../assets/img/common/splash_bg.png') no-repeat 0 0;
    background-size: cover;
    width: 100%;
    .logo_box {
      position: absolute;
      top: px2rem(450);
      left: px2rem(116);
      .logo {
        position: absolute;
        width: px2rem(526);
        height: px2rem(190);
      }

      .gear_big {
        display: inline-block;
        width: px2rem(36);
        height:px2rem(36);
        background: url('../assets/img/common/gear.png') no-repeat 0 0;
        background-size: 100%  100%;
        left: px2rem(300);
        top: px2rem(88);
        position: absolute;
        animation: change 1s linear infinite;
      }

      .gear_small {
        display: inline-block;
        width: px2rem(24);
        height:px2rem(24);
        background: url('../assets/img/common/gear.png') no-repeat 0 0;
        background-size: 100%  100%;
        left: px2rem(332);
        top: px2rem(80);
        position: absolute;
        animation: change 1s linear  infinite;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// Loading.vue?34c9c554